<template>
  <v-container class="fill-height" fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" md="6">
        <v-card class="pa-8 text-center">
          <v-card-title class="text-h5 justify-center">
            Your email has been verified. You can now sign in with your new account.
          </v-card-title>
          <v-card-text>
            <router-link
              to="/"
              class="text-subtitle-1"
              style="color: #97C657; text-decoration: none; font-weight: bold;"
            >
              Get Started with CertainFee
            </router-link>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'EmailVerified',
}
</script>
